"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PowerSignalType = void 0;
var PowerSignalType;
(function (PowerSignalType) {
    PowerSignalType["PowerGND"] = "gnd";
    PowerSignalType["PowerVCC"] = "vcc";
    PowerSignalType["PowerVEE"] = "vee";
    PowerSignalType["PowerAnalogGND"] = "agnd";
    PowerSignalType["PowerAnalogVCC"] = "avcc";
})(PowerSignalType || (exports.PowerSignalType = PowerSignalType = {}));
//# sourceMappingURL=PowerSignalType.js.map